import { type Ref, computed, ref } from 'vue'
import type { NDataTable } from 'naive-ui'

export interface EditCell {
  rowIndex: number | null
  key: string | null
}
export function useCDataTableEdit(dataTableRef: Ref<InstanceType<typeof NDataTable> | null>) {
  const editCell: Ref<EditCell> = ref({ rowIndex: null, key: null })
  const isEmptyEditCell = computed(() => editCell.value.rowIndex === null && editCell.value.key === null)
  const editCellTableFixedTdThPosition = computed(() => {
    return editCell.value.key !== null && editCell.value.rowIndex !== null ? `static` : `sticky`
  })
  const editCellTableOverflow = computed(() => {
    return !isEmptyEditCell.value ? `hidden` : `auto`
  })

  function onInlineInputUpdate() {
    dataTableRef.value!.$el.style.height = ''
    editCell.value = { rowIndex: null, key: null }
  }

  function onInlineInputCancel() {
    editCell.value = { rowIndex: null, key: null }
    dataTableRef.value!.$el.style.height = ''
  }

  function onInlineInputEdit({
    data,
    rowIndex,
    key,
    left = 0,
  }: {
    data: any[]
    rowIndex: number
    key: string
    left?: number
  }) {
    editCell.value = { rowIndex, key }
    setTimeout(() => {
      if (rowIndex === data.length - 1 && rowIndex !== 0) {
        dataTableRef.value!.scrollTo({ left: left, top: 999999 })
      } else if (rowIndex === 0 && data.length === 1) {
        const dataTableEl = dataTableRef.value!.$el
        const currentHeight = dataTableEl.clientHeight

        dataTableEl.style.height = `${currentHeight + 25}px`
      }
    }, 0)
  }

  function getInputState(rowIndex: number, key: string) {
    return editCell.value.rowIndex === rowIndex && editCell.value.key === key ? 'edit' : 'view'
  }

  return {
    editCell,
    isEmptyEditCell,
    editCellTableFixedTdThPosition,
    editCellTableOverflow,
    onInlineInputUpdate,
    onInlineInputCancel,
    onInlineInputEdit,
    getInputState,
  }
}
